// REACT
import React, { useEffect } from "react";

// REACT BOOTSTRAP
import { Col, Row } from "react-bootstrap";

// REACT HOOK FORM
import { useForm } from "react-hook-form";

// REDUX
import { useDispatch, useSelector } from "react-redux";

// REACT ROUTER
import { useParams } from "react-router-dom";

// INTERNATIONALIZATION
import { FormattedMessage } from "react-intl";

// STORE ACTIONS
import { refreshClientToken, editApplication } from "store/actions";

// HELPERS
import { getId } from "helpers/functions";

// COMPONENTS
import Input from "components/Form/input";
import SaveChangesButton from "components/Form/save-changes-button";
import FormWrapper from "components/Form/form-wrapper";

// ASSETS
import { ReactComponent as RefreshIcon } from "./assets/arrow-clockwise.svg";

const ApplicationsKeys = () => {
    const dispatch = useDispatch();
    const { applicationId } = useParams();
    const { singleApplication } = useSelector((state) => state.applications);

    let secondFormValues = {
        id: getId(singleApplication),
        token: singleApplication?.token || "",
        oauthMode: singleApplication?.oauthMode || "",
        callbackUrl: singleApplication?.callbackUrl || "",
    };
    const {
        handleSubmit: handleSubmitCredentials,
        getValues: getValuesCredentials,
        register: registerCredentials,
        watch: watchCredentials,
        formState: { errors: errorsCredentials },
        reset: resetCredentials,
    } = useForm();
    useEffect(() => {
        resetCredentials({
            ...secondFormValues,
        });
    }, [resetCredentials, singleApplication]);

    const onSubmitCredentials = (data) => {
        dispatch(
            editApplication({ endpointName: "keys", id: applicationId, data })
        );
    };
    return (
        <FormWrapper>
            <form onSubmit={handleSubmitCredentials(onSubmitCredentials)}>
                <Row>
                    <Col xs="12" md="4">
                        <h5 className="side-title">
                            <FormattedMessage id="appKeys" />
                        </h5>
                    </Col>
                    <Col xs="12" md="8">
                        <Row>
                            <Input
                                register={registerCredentials}
                                getValues={getValuesCredentials}
                                name="id"
                                copyable="true"
                                readOnly={true}
                                lg="12"
                            />
                            <Input
                                register={registerCredentials}
                                errors={errorsCredentials}
                                name="token"
                                type="password"
                                readOnly={true}
                                toggleView="true"
                                lg="12"
                                style={{ direction: "ltr" }}
                                extrabtnicon={<RefreshIcon />}
                                extrabtnfunc={() =>
                                    dispatch(refreshClientToken(applicationId))
                                }
                            />
                        </Row>
                        <Col xs="12">
                            <Input
                                register={registerCredentials}
                                errors={errorsCredentials}
                                name="oauthMode"
                                type="radio"
                                value="easyMode"
                                langId={false}
                            >
                                <p>
                                    <FormattedMessage id="easyMode" />
                                </p>
                            </Input>
                            <Input
                                register={registerCredentials}
                                errors={errorsCredentials}
                                name="oauthMode"
                                type="radio"
                                value="customMode"
                                langId={false}
                            >
                                <p>
                                    <FormattedMessage id="customMode" />
                                </p>
                            </Input>
                            {watchCredentials("oauthMode") == "customMode" && (
                                <Input
                                    register={registerCredentials}
                                    errors={errorsCredentials}
                                    name="callbackUrl"
                                    type="url"
                                />
                            )}
                        </Col>
                    </Col>
                </Row>
                <SaveChangesButton />
            </form>
        </FormWrapper>
    );
};

export default ApplicationsKeys;
